import { useGetSurchargeRelations } from 'queries';
import { useTranslation } from 'react-i18next';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import SurchargeRelations from './components/SurchargeRelations';

import useDelete from './hooks/useDelete';
import { useGetColumnDefs } from './hooks/useGetColumnDefs';

const SurchargeRelationsGrid = () => {
  const { t } = useTranslation('common', { keyPrefix: 'surchargeRelations' });
  const columns = useGetColumnDefs();
  const { data, isFetching } = useGetSurchargeRelations();
  const { mutate: deleteRow } = useDelete();

  return (
    <>
      <TableCRUDLayout
        rows={data}
        loading={isFetching}
        columns={columns}
        onDeleteClick={deleteRow}
        FormComponent={SurchargeRelations}
        getRowId={(row) => row.brEmployerLinkClientId}
        confirmationTitle={t('confirmationTitle')}
        confirmationBody={t('confirmationBody')}
      />
    </>
  );
};

export default SurchargeRelationsGrid;
